module.exports = __webpack_public_path__ + "img/3.217f3959.png";